import React, { useState } from 'react';
import BuzonList from './BuzonList';
import LoadSimple from '../LoadSimple';
import { capitalizeFirstLetter } from '../../utils/utils';
import { lang } from '../generales/traduction';
const TableBuzon = ({buscar_Buzon,startLimit,handleShowPopup,pageActual,limitList,languaje,mode, devices,editActive,dataBuzon,setDataBuzon, Buzonelected,setBuzonelected,registerIsValid,searchResults, setSearchResults,onSearch,dataUsers,setDataUsers,searchTerm, setSearchTerm,server,setRegisterIsValid,setData,setLoading,setError,handleChangEdit }) => {
  
  return (
    <div className='cont-table-portafolio'>
                                    <div className={"head-table-portafolio"+mode}>
                                    <div className="compact-head-table-portafolio">
                                        <div className='field-head-table-Buzon field-small'>
                                            No.
                                        </div>
                                        {/* <div className='field-head-table-Buzon field-medium' >
                                            {capitalizeFirstLetter(lang[languaje]['folio'])}
                                        </div>
                                        <div className='field-head-table-Buzon field-small'>
                                            Conf_ID
                                        </div> */}
                                        <div className='field-head-table-Buzon field-larger' style={{width:'25%'}}>
                                        {capitalizeFirstLetter(lang[languaje]['quienSolicita'])}
                                        </div>
                                        <div className='field-head-table-Buzon field-larger' style={{width:'25%'}}>
                                        {capitalizeFirstLetter(lang[languaje]['fechaSolicitud'])} 
                                        </div>
                                        <div className='field-head-table-Buzon field-larger' >
                                        {'Status'}  
                                        </div>
                                        <div className='field-head-table-Buzon field-larger' style={{width:'40%'}}>
                                        {capitalizeFirstLetter(lang[languaje]['comentarios'])}  
                                        </div>
                                        <div className='field-head-table-Buzon field-larger'>
                                        {capitalizeFirstLetter(lang[languaje]['acciones'])} 
                                        </div>
                                        
                                        </div>
                                    </div>
                                    <div className='body-table-cis-gs'>
                                      {
                                            ( registerIsValid)?<div className='cont-load-user-list'><LoadSimple></LoadSimple></div>:
                                            <BuzonList buscar_Buzon={buscar_Buzon} handleShowPopup={handleShowPopup} startLimit={startLimit} pageActual={pageActual} limitList={limitList}  languaje={languaje} mode={mode} dataBuzon={dataBuzon} setDataBuzon={setDataBuzon} editActive={editActive} devices={devices} Buzonelected={Buzonelected} setBuzonelected={setBuzonelected} searchResults={searchResults} setSearchResults={setSearchResults} searchTerm={searchTerm} setSearchTerm={setSearchTerm} dataUsers={dataUsers} setDataUsers={setDataUsers} server={server} setRegisterIsValid={setRegisterIsValid} setData={setData} setLoading={setLoading} setError={setError}  handleChangEdit={handleChangEdit}></BuzonList>
                                        
                                          }
                                        
                                        
                                    </div>
                                </div>
  );
}

export default TableBuzon;
